module.exports = __webpack_public_path__ + "img/forbidden-dark.43ee6c01.svg";